export const AUTH = {
    SET_USER: 'SET_USER',
    SET_AUTHENTICATED: 'SET_AUTHENTICATED'
}

export const GLOBAL = {
    SET_MESSAGE: 'SET_MESSAGE',
    RESET_MESSAGE: 'RESET_MESSAGE',
    SET_FEATURES_DATA: 'SET_FEATURES_DATA',
    INITIAL_SETTINGS_LOADED: 'INITIAL_SETTINGS_LOADED',
    SET_WINDOW_WIDTH: 'SET_WINDOW_WIDTH',
    SET_FEATURES_FREEROOM_DATA: 'SET_FEATURES_FREEROOM_DATA',
    SET_LOADING: 'SET_LOADING',
    RESET_COLOR: 'RESET_COLOR',
    SET_BLOCK_DIALOG: 'SET_BLOCK_DIALOG',
    SET_CORPORATE_NOTICE_DISPLAYED: 'CORPORATE_NOTICE_DISPLAYED',
    SET_INITIAL_SETTINGS: 'SET_INITIAL_SETTINGS',
    SET_BLOCK_DIALOG_TERMS: 'SET_BLOCK_DIALOG_TERMS',
    SET_BLOCK_DIALOG_NPS: 'SET_BLOCK_DIALOG_NPS'
}

export const CLIENT = {
    SET_CLIENT_CONFIG: 'SET_CLIENT_CONFIG',
    RESTORE_CLIENT_CONFIG: 'RESTORE_CLIENT_CONFIG',
    SET_CLIENT_ID: 'SET_CLIENT_ID'
}

export const USER_SETTINGS = {
    SET_SETTINGS: 'SET_SETTINGS'
}

export const ALERT = {
    SET_POLICY: 'SET_POLICY',
    SET_TERMS: 'SET_TERMS'
}